import React, { useState, useEffect } from 'react'

import { SuccessModal } from 'components'
import { useLoading } from 'hooks'
import useToggle from 'hooks/useToggle'
import { ReportCurrentContractService } from 'services/NGT/reportCurrentContract'

import { ReportsCurrent } from './components/ReportsCurrent'
import ReportsCurrentContract from './ReportsCurrentContracts'
import LoadingComponent from 'components/LoadingComponent/LoadingComponent'

export const ReportsContractCurrent: React.FC = () => {
  const [visualizar, setVisualizar] = useState(false)
  const [contratos, setContratos] = useState(null)
  const [tableData, setTableData] = useState()
  const [isError, toggleErrorModal] = useToggle()
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [firstGet, setFirstGet] = useState(true)
  const [loading, setLoading] = useState<string>('idle')

  return (
    <>
      {!visualizar && (
        <ReportsCurrentContract
          toggleErrorModal={toggleErrorModal}
          visualizar={setVisualizar}
          setTableData={setContratos}
          firstGet={firstGet}
          setFirstGet={() => setFirstGet(false)}
        />
      )}
      {visualizar && contratos && (
        <ReportsCurrent
          visualizar={setVisualizar}
          tableData={tableData}
          contratos={contratos}
          setTableData={setTableData}
        />
      )}
      <SuccessModal
        message={
          errorMessage || 'Infelizmente não foi possível realizar essa pesquisa'
        }
        open={isError}
        type={errorMessage ? 'alert' : 'error'}
        handleConfirm={() => {
          toggleErrorModal()
          setVisualizar(false)
        }}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      {loading === 'loading' ? <LoadingComponent /> : null}
    </>
  )
}
